/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getServicesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_CREATED_FARE_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getexcludedServicesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_EXCLUDED_FARE_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  }, 
  getServicefarebyid: (id) => {
    //console.log('url-->',API_ENDPOINTS.GET_SERVICE_FARE_DETAILS_BY_ID + "/" + id);
    return axios.get(API_ENDPOINTS.GET_SERVICE_FARE_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addservicefare: (data) => {
    return axios.post(API_ENDPOINTS.ADD_SERVICE_FARE, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  updateServicefare: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_SERVICE_FARE_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  deleteServicefare: (id) => {
    //console.log('url-->',API_ENDPOINTS.DELETE_SERVICE_FARE_BY_ID + "/" + id);
    return axios.delete(API_ENDPOINTS.DELETE_SERVICE_FARE_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
